import { useState } from 'react';
import { addDays, endOfDay, format, startOfDay } from 'date-fns';
import { useLazyGetScheduledExtractQuery } from '../../services/extractApi';
import { useFormatExtract } from '../useFormatExtract';
export function useGetScheduledExtract(canSeeStatements) {
    const { toScheduledExtract } = useFormatExtract();
    const [trigger] = useLazyGetScheduledExtractQuery();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [extract, setExtract] = useState();
    async function getScheduledExtract(startAt, endAt) {
        if (!canSeeStatements) {
            setLoading(false);
            setError(false);
            setExtract(undefined);
            return;
        }
        setLoading(true);
        setError(false);
        setExtract(undefined);
        try {
            const { data } = await trigger({
                startAt: startAt ?? format(startOfDay(new Date()), 'yyyy-MM-dd'),
                endAt: endAt ?? format(endOfDay(addDays(new Date(), 29)), 'yyyy-MM-dd'),
            }, false);
            if (!data?.result?.length || data?.result?.length === 0) {
                setError(true);
            }
            else {
                setExtract(toScheduledExtract(data.result));
            }
        }
        catch {
            setError(true);
        }
        finally {
            setLoading(false);
        }
    }
    return { loading, setLoading, error, setError, extract, setExtract, getScheduledExtract };
}
